// @ts-expect-error TS7016
import cloneDeep from 'lodash/cloneDeep'

type BaseEntity = {
  id?: number,
}

export const mergeAndStringifyEntityObjects = <Entity extends BaseEntity, EntityParams>(
  entity: Entity,
  entityParams: EntityParams,
  entityObjectKeys: (keyof Entity | keyof EntityParams)[] = [],
  entityArrayKeys: (keyof Entity | keyof EntityParams)[] = [],
): Entity & EntityParams => {
  const updatedEntityParams = {
    id: entity.id,
    ...entityParams,
  }

  entityObjectKeys.forEach((key) => {
    // @ts-expect-error TS2536
    const entityObject = entity[key] || {}
    // @ts-expect-error TS2536
    const entityParamsObject = entityParams[key] || {}

    // @ts-expect-error TS2536
    updatedEntityParams[key] = JSON.stringify({
      ...cloneDeep(entityObject),
      ...entityParamsObject,
    })
  })

  entityArrayKeys.forEach((key) => {
    // @ts-expect-error TS2536
    const entityParamsArray = entityParams[key] || []
    // @ts-expect-error TS2536
    updatedEntityParams[key] = JSON.stringify(entityParamsArray)
  })

  // @ts-expect-error TS2322
  return updatedEntityParams
}

export default mergeAndStringifyEntityObjects
